import { expand, pencil, tabletLandscapeOutline } from "ionicons/icons";

interface appListItem {
  name: string;
  label: string;
  tag: string;
  imageUrl?: string;
  svgIcon?: any;
  ionIcon?: string;
  ionIconSrc?: string;
  description?: string;
}

export const appListItems: appListItem[] = [
  {
    name: "find-resolution",
    label: "Find Resolution",
    tag: "tool",
    ionIcon: `${tabletLandscapeOutline}`,
    description: "Find resolution by knowing aspect ratio.",
  },
  {
    name: "find-aspect-ratio",
    label: "Find Aspect Ratio",
    tag: "tool",
    ionIcon: `${expand}`,
    description: "Find aspect ratio by knowing width and height.",
  },
  {
    name: "custom-aspect-ratio",
    label: "Custom Aspect Ratio",
    tag: "tool",
    ionIcon: `${pencil}`,
    description: "Discover more about a specific aspect ratio, including pixel density, physical dimensions, scaling tables, etc.",
  },
];

export let tagItems: string[] = [];
appListItems.forEach((item) => {
  if (item.tag) {
    const itemAr = item.tag.split(",");
    itemAr.forEach((tagItem) => {
      if (tagItems.indexOf(tagItem.toLowerCase().trim()) < 0) {
        tagItems.push(tagItem.toLowerCase());
      }
    });
  }
});

export const supportedTimezones: string[] = [
  "America/Adak",
  "America/Anchorage",
  "America/Boise",
  "America/Chicago",
  "America/Denver",
  "America/Detroit",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Los_Angeles",
  "America/Menominee",
  "America/Metlakatla",
  "America/New_York",
  "America/Nome",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Phoenix",
  "America/Sitka",
  "America/Yakutat",
  "Pacific/Honolulu",
  "America/Atikokan",
  "America/Blanc-Sablon",
  "America/Cambridge_Bay",
  "America/Creston",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Edmonton",
  "America/Fort_Nelson",
  "America/Glace_Bay",
  "America/Goose_Bay",
  "America/Halifax",
  "America/Inuvik",
  "America/Iqaluit",
  "America/Moncton",
  "America/Panama",
  "America/Phoenix",
  "America/Puerto_Rico",
  "America/Rankin_Inlet",
  "America/Regina",
  "America/Resolute",
  "America/St_Johns",
  "America/Swift_Current",
  "America/Toronto",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Winnipeg",
  "Europe/London",
  "Antarctica/Macquarie",
  "Asia/Tokyo",
  "Australia/Adelaide",
  "Australia/Brisbane",
  "Australia/Broken_Hill",
  "Australia/Darwin",
  "Australia/Eucla",
  "Australia/Hobart",
  "Australia/Lindeman",
  "Australia/Lord_Howe",
  "Australia/Melbourne",
  "Australia/Perth",
  "Australia/Sydney",
  "Pacific/Auckland",
  "Pacific/Chatham",
];

export const isSupportedCountry = (supportedTimezones.findIndex(country => country === Intl.DateTimeFormat().resolvedOptions().timeZone) > -1)